import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Environment
import { environment } from './../../../environments/environment';

// Components
import { AuthorizationComponent } from './authorization/authorization.component';
import { CookiesPoliticsComponent } from './cookies-politics/cookies-politics.component';
import { PoliticsComponent } from './politics/politics.component';
import { ServicePoliticsComponent } from './service-politics/service-politics.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
    {
        path: 'autorizacion-de-datos',
        component: AuthorizationComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        }
    },
    {
        path: 'politica-de-privacidad',
        component: PoliticsComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        }
    },
    {
        path: 'terminos-y-condiciones',
        component: TermsComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        }
    },
    {
        path: 'politica-de-servicios',
        component: ServicePoliticsComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        }
    },
    {
        path: 'politica-de-cookies',
        component: CookiesPoliticsComponent,
        data: {
            meta: {
                robots: environment.statusMetaIndexSpecific
            }
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class LegalRoutingModule { }
